import React from 'react';
import { withRouter } from 'react-router';
import {
  List,
  Rate,
  Row,
  Col
} from 'antd';
import { connect } from 'react-redux';
import { likeReviewAction, openLoginModel, getReviewsAction } from '../../store/actions/index'
import { converInUpperCase, dateFormat4 } from '../common'
import { LikeOutlined, LikeTwoTone } from '@ant-design/icons';
import ReportReview from '../../modals/reviews/ReportReview'
import UpdateReviewModel from '../../modals/reviews/LeaveReviewModel'
import { REVIEW_TYPE } from '../../config/Config';


class ReviewList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      seeMore: false,
      list: [],
      classifiedDetail: '',
      selectedReview: '',
      reportReviewModel: false,
      editReviewModel: false,

    };
  }

  /**
   * @method likeReview
   * @description like this review
   */
  likeReview = (item) => {
    let reqData = {
      module: REVIEW_TYPE.PRODUCT,
      review_id: item.id,
      is_like: item.no_of_votes && item.no_of_votes.length && item.no_of_votes[0].is_like === 1 ? 0 : 1
    }
    this.props.likeReviewAction(reqData, () => {
      this.props.getReviewsList();
    })
  }


  handleReportReview = (item) => {
    const { isLoggedIn } = this.props
    if (isLoggedIn) {
      this.setState({ reportReviewModel: true, selectedReview: item })
    } else {
      this.props.openLoginModel()
    }
  }

  /**
   * @method updateReview
   * @description update review
   */
  updateReview = (item) => {
    const { isLoggedIn } = this.props
    if (isLoggedIn) {
      this.setState({ editReviewModel: true, selectedReview: item })
    } else {
      this.props.openLoginModel()
    }
  }

  /**
   * @method render
   * @description render component
   */
  render() {
    const { classifiedDetail, userList, isLoggedIn, loggedInUser, reviewList } = this.props
    const { editReviewModel, selectedReview, reportReviewModel, seeMore } = this.state

    let temp = [];
    if (userList && Array.isArray(userList)) {
      if (userList && userList.length <= 4) {
        temp = userList.slice(0, userList.length);
      } else {
        let len = !this.state.seeMore ? 4 : userList.length;
        temp = userList && userList.slice(0, len);
      }
    }
    return (
      <div className="review-detail-block">
        <List
          className='reviewListing'
          itemLayout='vertical'
          dataSource={reviewList?.data ?? []}
          renderItem={item => (
            <List.Item>
              <Row gutter={[20, 20]}>
                <Col xs={{ span: 24 }} lg={{ span: 6 }} className="left">
                  <Rate disabled value={Number(item.rating)} className='fs-16 mb-7' />
                  <span>
                    by <u>{item.reviews_by && converInUpperCase(item.reviews_by.name)}</u>
                  </span>
                  <span className="date">{dateFormat4(item.created_at)}</span>
                  <span className="reportReview" style={{ cursor: 'pointer' }}
                    onClick={() => this.handleReportReview(item)}
                  >Report review</span>


                  {/* {item.confirmed_purchase && <div className="review-date-detail">
                    <h5>Confirmed purchase</h5>
                    <span className="date">
                      {dateFormat4(item.confirmed_purchase.date)}
                    </span>
                  </div>} */}

                  {/* <div className="review-date-detail">
                    <h5>Published on</h5>
                    <span className="date">{dateFormat4(item.created_at)}</span>
                  </div> */}
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 18 }} className="right">
                  <div className="reviewHeading">{item.title && item.title}</div>
                  <div className='reviewData'>{item.review && item.review}</div>
                  <div className='reviewFooter'>
                    <span>
                      {item.user_liked ?
                        <LikeTwoTone onClick={() => {
                          if (this.props.isLoggedIn) {
                            this.likeReview(item)
                          } else {
                            this.props.openLoginModel()
                          }
                        }} /> : <LikeOutlined onClick={() => {
                          if (this.props.isLoggedIn) {
                            this.likeReview(item)
                          } else {
                            this.props.openLoginModel()
                          }
                        }} />}
                    </span>

                    <span>{item.review_votes_count}</span>
                    <span style={{ fontSize: "18px", fontWeight: "500" }}>·</span>
                    <span>{item?.replies?.length ?? "0"} Comment</span>

                    {item.reviews_by?.id === loggedInUser?.id &&
                      <span className="blue-link" style={{ cursor: 'pointer' }}
                        onClick={() => this.updateReview(item)}
                      >Edit</span>}
                  </div>
                </Col>
              </Row>
            </List.Item>
          )}
        />
        <div className='align-right'>
          {/** Show Pagination reviewList*/}
        </div>
        {reportReviewModel &&
          <ReportReview
            visible={reportReviewModel}
            module={REVIEW_TYPE.PRODUCT}
            onCancel={() => this.setState({ reportReviewModel: false })}
            selectedReview={selectedReview}
            is_retail={true}
          />}
        {editReviewModel &&
          <UpdateReviewModel
            visible={editReviewModel}
            module={REVIEW_TYPE.PRODUCT}
            onCancel={() => this.setState({ editReviewModel: false })}
            classifiedDetail={classifiedDetail && classifiedDetail}
            selectedReview={selectedReview}
            callNext={() => this.props.getReviewsList(this.props.reviewpage)}
          />}
      </div>
    );
  }
}
//  Connect with redux through connect methode
const mapStateToProps = (store) => {
  const { auth: { loggedInUser, isLoggedIn } } = store;
  return { loggedInUser, isLoggedIn };
};
export default connect(mapStateToProps, {
  likeReviewAction,
  getReviewsAction,
  openLoginModel
})(withRouter(ReviewList));